/* Florea wishlist: share dialog (replaces prompt/clipboard-only flow) */
(function () {
  'use strict';
  if (window.__fwShareLoaded) return;
  window.__fwShareLoaded = true;

  var L = {
    sv: ['Kopiera länk', 'Skicka länken till någon så kan de se din önskelista.', 'Dela', 'Länk kopierad'],
    en: ['Copy link', 'Send the link to anyone so they can see your wishlist.', 'Share', 'Link copied'],
    nb: ['Kopier lenke', 'Send lenken til noen, så kan de se ønskelisten din.', 'Del', 'Lenke kopiert'],
    da: ['Kopiér link', 'Send linket til nogen, så kan de se din ønskeliste.', 'Del', 'Link kopieret'],
    fi: ['Kopioi linkki', 'Lähetä linkki, niin vastaanottaja näkee toivelistasi.', 'Jaa', 'Linkki kopioitu'],
    de: ['Link kopieren', 'Schick den Link an jemanden, damit er deine Wunschliste sehen kann.', 'Teilen', 'Link kopiert'],
    fr: ['Copier le lien', 'Envoyez ce lien pour partager votre liste de souhaits.', 'Partager', 'Lien copié'],
    pl: ['Kopiuj link', 'Wyślij link, aby ktoś mógł zobaczyć Twoją listę życzeń.', 'Udostępnij', 'Link skopiowany'],
    it: ['Copia link', 'Invia il link per condividere la tua lista dei desideri.', 'Condividi', 'Link copiato'],
    es: ['Copiar enlace', 'Envía el enlace para compartir tu lista de deseos.', 'Compartir', 'Enlace copiado']
  };

  var css = '' +
    '.fw-share{position:fixed;inset:0;z-index:1002;display:flex;align-items:flex-end;justify-content:center;background:rgba(35,39,43,.45);opacity:0;visibility:hidden;transition:opacity .2s ease,visibility .2s}' +
    '.fw-share.is-open{opacity:1;visibility:visible}' +
    '.fw-share__box{position:relative;width:100%;max-width:440px;box-sizing:border-box;margin:0 12px 12px;padding:22px 20px 20px;background:#fff;color:#23272b;border-radius:8px;box-shadow:0 10px 30px rgba(35,39,43,.2);display:flex;flex-direction:column;gap:12px;transform:translateY(12px);transition:transform .2s ease}' +
    '.fw-share.is-open .fw-share__box{transform:translateY(0)}' +
    '.fw-share__title{margin:0;padding-right:28px}' +
    '.fw-share__text{margin:0;font-size:1.3rem;color:var(--color-foreground-secondary,#757575)}' +
    '.fw-share__input{width:100%;box-sizing:border-box;min-height:44px;padding:0 12px;border:1px solid #d9d6cc;background:#f6f5ef;font:inherit;font-size:1.3rem;color:#23272b}' +
    '.fw-share__btns{display:flex;flex-direction:column;gap:8px}' +
    '.fw-share__btns .btn{width:100%;min-width:0;justify-content:center;text-align:center}' +
    '.fw-share__close{position:absolute;top:10px;right:10px;width:32px;height:32px;padding:0;border:0;border-radius:50%;background:transparent;color:#23272b;cursor:pointer;display:inline-flex;align-items:center;justify-content:center}' +
    '.fw-share__close:hover{background:#f1f1f1}' +
    '@media only screen and (min-width:750px){.fw-share{align-items:center}.fw-share__box{margin:0}.fw-share__btns{flex-direction:row}.fw-share__btns .btn{flex:1}}' +
    '@media (prefers-reduced-motion:reduce){.fw-share,.fw-share__box{transition:none}}';

  function start() {
    var W = window.FloreaWishlistApi;
    if (!W) return;
    var C = W.C || {}, S = W.S || {};
    var lang = String(C.locale || document.documentElement.lang || 'sv').toLowerCase().split('-')[0];
    if (lang === 'no' || lang === 'nn') lang = 'nb';
    var T = L[lang] || L.sv;

    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    var wrap = null, input = null, copyBtn = null, lastFocus = null;

    function close() {
      if (!wrap) return;
      wrap.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    function copy(link) {
      function fallback() {
        try {
          input.removeAttribute('readonly');
          input.focus();
          input.select();
          input.setSelectionRange(0, link.length);
          var ok = document.execCommand && document.execCommand('copy');
          input.setAttribute('readonly', '');
          return !!ok;
        } catch (e) { return false; }
      }
      function done(ok) {
        if (ok) {
          copyBtn.textContent = (S.link_copied || T[3]) + ' ✓';
          setTimeout(function () { copyBtn.textContent = T[0]; }, 2000);
        } else {
          input.focus();
          input.select();
        }
      }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
          navigator.clipboard.writeText(link).then(function () { done(true); }, function () { done(fallback()); });
          return;
        }
      } catch (e) { /* fall through */ }
      done(fallback());
    }

    function open(link) {
      lastFocus = document.activeElement;
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'fw-share';
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-modal', 'true');
        wrap.setAttribute('aria-labelledby', 'fw-share-title');
        wrap.innerHTML =
          '<div class="fw-share__box">' +
          '<button type="button" class="fw-share__close" data-fw-share-close>' +
          '<svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="2" fill="none"/></svg></button>' +
          '<h2 class="h5 fw-share__title" id="fw-share-title"></h2>' +
          '<p class="fw-share__text"></p>' +
          '<input class="fw-share__input" type="text" readonly>' +
          '<div class="fw-share__btns"><button type="button" class="btn btn--primary" data-fw-share-copy></button></div>' +
          '</div>';
        document.body.appendChild(wrap);
        wrap.querySelector('.fw-share__title').textContent = S.share || '';
        wrap.querySelector('.fw-share__text').textContent = T[1];
        wrap.querySelector('[data-fw-share-close]').setAttribute('aria-label', S.close || '');
        input = wrap.querySelector('.fw-share__input');
        copyBtn = wrap.querySelector('[data-fw-share-copy]');
        copyBtn.textContent = T[0];
        if (navigator.share) {
          var nb = document.createElement('button');
          nb.type = 'button';
          nb.className = 'btn btn--secondary';
          nb.textContent = T[2];
          nb.addEventListener('click', function () {
            navigator.share({ title: S.my_title || S.title || '', url: input.value }).catch(function () { /* cancelled */ });
          });
          wrap.querySelector('.fw-share__btns').appendChild(nb);
        }
        wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
        wrap.querySelector('[data-fw-share-close]').addEventListener('click', close);
        copyBtn.addEventListener('click', function () { copy(input.value); });
        input.addEventListener('focus', function () { input.select(); });
      }
      input.value = link;
      copyBtn.textContent = T[0];
      wrap.classList.add('is-open');
      document.addEventListener('keydown', onKey);
      setTimeout(function () { copyBtn.focus(); }, 50);
    }

    var busy = false;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-wl-share]') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy) return;
      var st = W.state || {};
      var body = {};
      if (!st.loggedIn) {
        var items = (st.items || []).slice().sort(function (a, b) {
          return String(b.addedAt || '').localeCompare(String(a.addedAt || ''));
        }).slice(0, 200).map(function (i) { return String(i.productId); });
        if (!items.length) return;
        body.items = items;
      }
      busy = true;
      btn.disabled = true;
      W.api('share', 'POST', body).then(function (r) {
        if (!r || !r.token) throw new Error('no_token');
        open(window.location.origin + (W.PREFIX || '') + '/pages/wishlist?shared=' + encodeURIComponent(r.token));
      }).catch(function (err) {
        if (window.console) console.warn('[wishlist] share failed', err);
        W.toast(S.error || '');
      }).then(function () { busy = false; btn.disabled = false; });
    }, true);
  }

  if (window.FloreaWishlistApi) start();
  else document.addEventListener('florea-wishlist:api', start, { once: true });
})();
